import React from "react";
import {
    Checkbox, Divider,
    FormControl,
    FormControlLabel,
    FormGroup,
    InputLabel,
    MenuItem,
    Select, Slider, TextField,
    Typography, withStyles
} from "@material-ui/core";
import { enabledField, valueText } from "./index";
import { blockInvalidChar } from "../sc-utilities";

const styles = theme => ({
    root: {
        height: 'auto',
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    form: {
        width: '95%',
        margin: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    submit: {
        width: "100%",
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2),
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    addButton: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2),
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    text: {
        borderRadius: '1px',
        marginRight: 10,
        color: theme.palette.buttonText.default
    },
    divider: {
        margin: theme.spacing(1),

    },
    wifiDivider: {
        margin: "15px 0px",
    },
    formControl: {
        width: "100%"
    },
    row: {
        display: 'row',
        width: "auto",
        alignItems: 'center'
    },
    smartScore: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    presetSmartScoreInput: {
        display: "flex",
        alignItems: "center"
    },
    presetSmartScore: {
        marginLeft: "10px"
    }
});

const PresetWorkSettings = (props) => {
    const { classes, translations, handleChange, values, orderID, orders, transportColliID, colliID, collies, setFieldValue, verify, methods, eraseOnlyName, gradeID, grades, operatingSystemID, operatingSystems, printerID, printers, setValues, valuesDiskHealth, skuPatterns, skuPatternID } = props;

    const fieldNames = {
        PresetsEnabled: `${eraseOnlyName}.PresetsEnabled`,
        AutoShutdown: `${eraseOnlyName}.AutoShutdown`,
        AutoEnableRemoteAccess: `${eraseOnlyName}.AutoEnableRemoteAccess`,
        AutoStartErasure: `${eraseOnlyName}.AutoStartErasure`,
        AutoStartDiagnose: `${eraseOnlyName}.AutoStartDiagnose`,
        // AutoPrint: `${eraseOnlyName}.AutoPrint`,
        automaticUnfreeze: `${eraseOnlyName}.automaticUnfreeze`,
        OrderID: `${eraseOnlyName}.OrderID`,
        TransportColliID: `${eraseOnlyName}.TransportColliID`,
        ColliID: `${eraseOnlyName}.ColliID`,
        MethodSSD: `${eraseOnlyName}.MethodSSD`,
        VerificationSSD: `${eraseOnlyName}.VerificationSSD`,
        CustomValueSSD: `${eraseOnlyName}.CustomValueSSD`,
        MethodHDD: `${eraseOnlyName}.MethodHDD`,
        VerificationHDD: `${eraseOnlyName}.VerificationHDD`,
        CustomValueHDD: `${eraseOnlyName}.CustomValueHDD`,
        UsePresetSmartScore: `${eraseOnlyName}.UsePresetSmartScore`,
        PresetSmartScore: `${eraseOnlyName}.PresetSmartScore`,
        PrinterID: `${eraseOnlyName}.PrinterID`,
        GradeID: `${eraseOnlyName}.GradeID`,
        OperatingSystemID: `${eraseOnlyName}.OperatingSystemID`,
        ProcessingSessionEndMessage: `${eraseOnlyName}.ProcessingSessionEndMessage`,
        NormalScreenBrightness: `${eraseOnlyName}.NormalScreenBrightness`,
        ReducedScreenBrightness: `${eraseOnlyName}.ReducedScreenBrightness`,
        SmartHealthCalculation: `${eraseOnlyName}.SmartHealthCalculation`,
        SKUPatternID: `${eraseOnlyName}.SKUPatternID`,
        PrintUponConnection: `${eraseOnlyName}.PrintUponConnection`,
        PrintUponSuccessfulErasure: `${eraseOnlyName}.PrintUponSuccessfulErasure`,
        PrintUponFailedOrAbortedErasure: `${eraseOnlyName}.PrintUponFailedOrAbortedErasure`,
        PrintUponDiagnose: `${eraseOnlyName}.PrintUponDiagnose`,
    }

    const fieldValues = {
        PresetsEnabled: values[eraseOnlyName]["PresetsEnabled"],
        AutoShutdown: values[eraseOnlyName]["AutoShutdown"],
        AutoEnableRemoteAccess: values[eraseOnlyName]["AutoEnableRemoteAccess"],
        AutoStartErasure: values[eraseOnlyName]["AutoStartErasure"],
        AutoStartDiagnose: values[eraseOnlyName]["AutoStartDiagnose"],
        // AutoPrint: values[eraseOnlyName]["AutoPrint"],
        automaticUnfreeze: values[eraseOnlyName]["automaticUnfreeze"],
        OrderID: values[eraseOnlyName]["OrderID"],
        TransportColliID: values[eraseOnlyName]["TransportColliID"],
        ColliID: values[eraseOnlyName]["ColliID"],
        MethodSSD: values[eraseOnlyName]["MethodSSD"],
        VerificationSSD: values[eraseOnlyName]["VerificationSSD"],
        CustomValueSSD: values[eraseOnlyName]["CustomValueSSD"],
        MethodHDD: values[eraseOnlyName]["MethodHDD"],
        VerificationHDD: values[eraseOnlyName]["VerificationHDD"],
        CustomValueHDD: values[eraseOnlyName]["CustomValueHDD"],
        UsePresetSmartScore: values[eraseOnlyName]["UsePresetSmartScore"],
        PresetSmartScore: values[eraseOnlyName]["PresetSmartScore"],
        PrinterID: values[eraseOnlyName]["PrinterID"],
        GradeID: values[eraseOnlyName]["GradeID"],
        OperatingSystemID: values[eraseOnlyName]["OperatingSystemID"],
        ProcessingSessionEndMessage: values[eraseOnlyName]["ProcessingSessionEndMessage"],
        NormalScreenBrightness: values[eraseOnlyName]["NormalScreenBrightness"],
        ReducedScreenBrightness: values[eraseOnlyName]["ReducedScreenBrightness"],
        SmartHealthCalculation: values[eraseOnlyName]["SmartHealthCalculation"],
        SKUPatternID: values[eraseOnlyName]["SKUPatternID"],
        PrintUponConnection: values[eraseOnlyName]["PrintUponConnection"],
        PrintUponSuccessfulErasure: values[eraseOnlyName]["PrintUponSuccessfulErasure"],
        PrintUponFailedOrAbortedErasure: values[eraseOnlyName]["PrintUponFailedOrAbortedErasure"],
        PrintUponDiagnose: values[eraseOnlyName]["PrintUponDiagnose"],
    }

    return (
        <>
            <Typography align='center' variant={"h5"}>{translations['preset_basic'] || 'Preset basic'}</Typography>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={"dense"}
                            name={fieldNames["PresetsEnabled"]}
                            checked={fieldValues["PresetsEnabled"] || false}
                            onChange={handleChange}
                        />
                    }
                    label={`${translations['enable_preset'] || 'Enable preset'}`}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={"dense"}
                            name={fieldNames["AutoShutdown"]}
                            checked={fieldValues["AutoShutdown"] || false}
                            disabled={enabledField(values)}
                            onChange={handleChange}
                        />
                    }
                    label={`${translations['auto_shut_down'] || 'Auto shut down'}`}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={"dense"}
                            name={fieldNames["AutoEnableRemoteAccess"]}
                            checked={fieldValues["AutoEnableRemoteAccess"] || false}
                            disabled={enabledField(values)}
                            onChange={handleChange}
                        />
                    }
                    label={translations['auto_enable_remote_access'] || 'Auto enable remote access'}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={"dense"}
                            name={fieldNames["AutoStartErasure"]}
                            checked={fieldValues["AutoStartErasure"] || false}
                            onChange={handleChange}
                            disabled={enabledField(values)}
                        />
                    }
                    label={`${translations['autostart_erasure'] || 'Autostart erasure'}`}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={"dense"}
                            name={fieldNames["PrintUponConnection"]}
                            checked={(fieldValues["PrintUponConnection"]) || false}
                            disabled={enabledField(values)}
                            onChange={handleChange}
                        />
                    }
                    label={`${translations['print_upon_connection'] || 'Print upon connection'}`}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={"dense"}
                            name={fieldNames["PrintUponSuccessfulErasure"]}
                            checked={(fieldValues["PrintUponSuccessfulErasure"]) || false}
                            disabled={enabledField(values)}
                            onChange={handleChange}
                        />
                    }
                    label={`${translations['print_upon_successful_erasure'] || 'Print upon successful erasure'}`}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={"dense"}
                            name={fieldNames["PrintUponFailedOrAbortedErasure"]}
                            checked={(fieldValues["PrintUponFailedOrAbortedErasure"]) || false}
                            disabled={enabledField(values)}
                            onChange={handleChange}
                        />
                    }
                    label={`${translations['print_upon_failed_or_aborted_erasure'] || 'Print upon failed or aborted erasure'}`}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={"dense"}
                            name={fieldNames["PrintUponDiagnose"]}
                            checked={(fieldValues["PrintUponDiagnose"]) || false}
                            disabled={enabledField(values)}
                            onChange={handleChange}
                        />
                    }
                    label={`${translations['print_upon_diagnose'] || 'Print upon diagnose'}`}
                />
            </FormGroup>
            {/* <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={"dense"}
                            name={fieldNames["AutoPrint"]}
                            checked={fieldValues["AutoPrint"] || false}
                            onChange={handleChange}
                            disabled={enabledField(values)}
                        />
                    }
                    label={`${translations['auto_print_label'] || 'Auto print label'}`}
                />
            </FormGroup> */}
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={"dense"}
                            name={fieldNames["automaticUnfreeze"]}
                            checked={fieldValues["automaticUnfreeze"] || false}
                            onChange={handleChange}
                            disabled={enabledField(values)}
                        />
                    }
                    label={`${translations['automatic_unfreeze'] || 'Automatic unfreeze'}`}
                />
            </FormGroup>
            {eraseOnlyName === "Normal" ? 
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color={'primary'}
                                margin={"dense"}
                                name={fieldNames["AutoStartDiagnose"]}
                                checked={fieldValues["AutoStartDiagnose"] || false}
                                onChange={handleChange}
                                disabled={enabledField(values)}
                            />
                        }
                        label={`${translations['autostart_diagnose'] || 'Autostart diagnose'}`}
                    />
                </FormGroup> :
                null
            }
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations["sku_select"] || "Please select SKU pattern"}</InputLabel>
                <Select
                    name={fieldNames["SKUPatternID"]}
                    value={skuPatternID ? fieldValues["SKUPatternID"] : ''}
                    label={translations["sku_pattern"] || 'SKU Pattern'}
                    margin={"dense"}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {(skuPatterns ? skuPatterns : []).map(option => (
                        <MenuItem key={option.SKUPatternID} value={option.SKUPatternID}>
                            {option.Name} - {option.Pattern}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations["order_select"] || "Please select order"}</InputLabel>
                <Select
                    name={fieldNames["OrderID"]}
                    value={orderID ? fieldValues["OrderID"] : ''}
                    label={translations["order"] || 'Order'}
                    margin={"dense"}
                    onChange={(event) => { setFieldValue(fieldNames["TransportColliID"], ''); handleChange(event); return event.stopPropagation() }}
                    disabled={enabledField(values)}
                >
                    <MenuItem value="">
                        <em>{translations["list_view"] || "List view"}</em>
                    </MenuItem>
                    {(orders ? orders : []).map(option => (
                        <MenuItem key={option.OrderID} value={option.OrderID}>
                            {option.Name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations["transport_colli_text"] || "Please select transport colli"}</InputLabel>
                <Select
                    name={fieldNames["TransportColliID"]}
                    label={translations["transport_colli"] || 'Transport Colli'}
                    margin={"dense"}
                    value={transportColliID ? fieldValues["TransportColliID"] : ''}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    <MenuItem value="">
                        <em>{translations["list_view"] || "List view"}</em>
                    </MenuItem>
                    {(orders?.length > 0 ? orders.filter(order => order.OrderID === fieldValues["OrderID"] ? fieldValues["OrderID"] : '') : []).map(
                        order => {
                            return order.TransportCollies.map(option => (
                                <MenuItem key={option.TransportColliID} value={option.TransportColliID}>
                                    {option.Name}
                                </MenuItem>

                            ))
                        }
                    )}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations["colli_text"] || "Please select container"}</InputLabel>
                <Select
                    name={fieldNames["ColliID"]}
                    label={translations["colli"] || 'Colli'}
                    margin={"dense"}
                    value={colliID ? fieldValues["ColliID"] : ''}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    <MenuItem value="">
                        <em>{translations["list_view"] || "List view"}</em>
                    </MenuItem>
                    {(collies ? collies : []).map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <Divider className={classes.divider} variant="middle" />
            <Typography align="center" variant={"h5"}>{translations['erasure_ssd'] || 'Erasure SSD'}</Typography>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations['wipe_method_ssd_text'] || "Please select ssd erasure method"}</InputLabel>
                <Select
                    name={fieldNames["MethodSSD"]}
                    label={translations['wipe_method_ssd'] || 'SSD Erasure method'}
                    margin={"dense"}
                    value={fieldValues["MethodSSD"] || ""}
                    onChange={handleChange}
                    disabled={enabledField(values)}

                >
                    {(methods ? methods : []).map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations["wipe_verify_ssd_text"] || "Please select ssd verify method"}</InputLabel>
                <Select
                    name={fieldNames["VerificationSSD"]}
                    label={translations['VerificationSSD'] || 'Wipe verify ssd'}
                    margin={"dense"}
                    value={fieldValues["VerificationSSD"] || ''}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {(verify ? verify : []).map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {fieldValues["VerificationSSD"] === 'custom' ?
                <>
                    <InputLabel shrink>{translations["wipe_verify_ssd_number"] || "Please select number of rounds for SSD"}</InputLabel>
                    <Slider
                        name={fieldNames["CustomValueSSD"]}
                        valueLabelFormat={valueText}
                        onChange={(event, value) => setFieldValue(fieldNames["CustomValueSSD"], value)}
                        valueLabelDisplay="on"
                        aria-labelledby="discrete-slider"
                        value={fieldValues["CustomValueSSD"]}
                        step={1}
                        marks
                        min={0}
                        max={100}
                        disabled={enabledField(values)}
                    />  </> : <> </>}
            <Divider className={classes.divider} variant="middle" />
            <Typography align="center" variant={"h5"}>{translations['erasure_hdd'] || 'Erasure HDD'}</Typography>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations['wipe_method_hdd_text'] || "Please select hdd erasure method"}</InputLabel>
                <Select
                    name={fieldNames["MethodHDD"]}
                    label={translations['wipe_method_hdd'] || 'HDD Erasure method'}
                    margin={"dense"}
                    value={fieldValues["MethodHDD"] || ""}
                    onChange={handleChange}
                    disabled={enabledField(values)}

                >
                    {(methods ? methods : []).map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations["wipe_verify_hdd_text"] || "Please select hdd verify method"}</InputLabel>
                <Select
                    name={fieldNames["VerificationHDD"]}
                    label={translations['VerificationHDD'] || 'Wipe verify hdd'}
                    margin={"dense"}
                    value={fieldValues["VerificationHDD"] || ""}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {(verify ? verify : []).map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {fieldValues["VerificationHDD"] === 'custom' ?
                <>
                    <InputLabel shrink>{translations["wipe_verify_hdd_number"] || "Please select number of rounds for HDD"}</InputLabel>
                    <Slider
                        name={fieldNames["CustomValueHDD"]}
                        defaultValue={0}
                        valueLabelFormat={valueText}
                        onChange={(event, value) => setFieldValue(fieldNames["CustomValueHDD"], value)}
                        valueLabelDisplay="on"
                        aria-labelledby="discrete-slider"
                        value={fieldValues["CustomValueHDD"]}
                        step={1}
                        marks
                        min={0}
                        max={100}
                        disabled={enabledField(values)}
                    />  </> : <> </>}

            <FormGroup className={classes.smartScore}>
                <Checkbox
                    color={'primary'}
                    margin={"dense"}
                    name={fieldNames["UsePresetSmartScore"]}
                    checked={!!fieldValues["UsePresetSmartScore"] || false}
                    onChange={(e) => {
                        if (!e.target.checked) {
                            setValues({ ...values, [eraseOnlyName]: { ...values[eraseOnlyName], PresetSmartScore: null, UsePresetSmartScore: e.target.checked } });
                        } else {
                            handleChange(e)
                        }
                    }}
                    disabled={enabledField(values)}
                />
                <Typography align='center' className={classes.presetSmartScoreInput} variant={"body2"}>{translations['preset_smart_score'] || 'Don\'t erase drives with worse SMART score than'}:</Typography>
                <TextField
                    name={fieldNames["PresetSmartScore"]}
                    className={classes.presetSmartScore}
                    disabled={enabledField(values) || !fieldValues["UsePresetSmartScore"]}
                    value={fieldValues["PresetSmartScore"] !== null ? fieldValues["PresetSmartScore"] : ''}
                    onChange={(e) => {
                        if (e.target.value >= 0 && e.target.value <= 100) {
                            handleChange(e)
                        }
                    }}
                    type="number"
                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', min: 0, max: 100 }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onKeyDown={blockInvalidChar}
                />
            </FormGroup>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations["disk_health_calculation"] || "Disk Health Calculation"}</InputLabel>
                <Select
                    name={fieldNames["SmartHealthCalculation"]}
                    label={translations['disk_health_calculation'] || 'Disk Health Calculation'}
                    margin={"dense"}
                    value={fieldValues["SmartHealthCalculation"] || "securaze"}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {valuesDiskHealth.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <Divider className={classes.divider} variant="middle" />
            <Typography align='center' variant={"h5"}>{translations['preset_advanced'] || 'Presets advanced'}</Typography>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations["normal_screen_brightness"] || "Please choose normal screen brightness (e.g. after login, while entering data)"}</InputLabel>
                <br />
                <Slider
                    name={fieldNames["NormalScreenBrightness"]}
                    value={fieldValues["NormalScreenBrightness"]}
                    valueLabelFormat={valueText}
                    onChange={(event, value) => setFieldValue(fieldNames["NormalScreenBrightness"], value)}
                    valueLabelDisplay="on"
                    aria-labelledby="discrete-slider"
                    step={1}
                    marks
                    min={20}
                    max={100}
                    disabled={enabledField(values)}
                />
            </FormControl>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations["reduced_screen_brightness"] || "Please choose reduced screen brightness (e.g. during screensaver is visible)"}</InputLabel>
                <br />
                <Slider
                    name={fieldNames["ReducedScreenBrightness"]}
                    value={fieldValues["ReducedScreenBrightness"]}
                    valueLabelFormat={valueText}
                    onChange={(event, value) => setFieldValue(fieldNames["ReducedScreenBrightness"], value)}
                    valueLabelDisplay="on"
                    aria-labelledby="discrete-slider"
                    step={1}
                    marks
                    min={0}
                    max={100}
                    disabled={enabledField(values)}
                />
            </FormControl>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations["printers_text"] || "Please select printer"}</InputLabel>
                <Select
                    name={fieldNames["PrinterID"]}
                    label={translations["printers"] || 'Printers'}
                    margin={"dense"}
                    value={printerID && fieldValues["PrinterID"] ? fieldValues["PrinterID"] : ''}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {(printers ? printers : []).map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations["grade_text"] || "Please select grade"}</InputLabel>
                <Select
                    name={fieldNames["GradeID"]}
                    label={translations['grade'] || 'Grade'}
                    margin={"dense"}
                    defaultValue={''}
                    value={gradeID && fieldValues["GradeID"] ? fieldValues["GradeID"] : ''}
                    onChange={handleChange}
                    disabled={enabledField(values)}

                >
                    {(grades ? grades : []).map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={"dense"}>
                <InputLabel shrink>{translations["operating_system_text_select"] || "Please select operating system"}</InputLabel>
                <Select
                    name={fieldNames["OperatingSystemID"]}
                    label={translations["operating_system"] || 'Operating System'}
                    margin={"dense"}
                    value={operatingSystemID && fieldValues["OperatingSystemID"] ? fieldValues["OperatingSystemID"] : ''}
                    onChange={handleChange}
                    disabled={enabledField(values)}

                >
                    {(operatingSystems ? operatingSystems : []).map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField
                name={fieldNames["ProcessingSessionEndMessage"]}
                value={fieldValues["ProcessingSessionEndMessage"] || ""}
                onChange={handleChange}
                placeholder={translations['processing_session_end_message'] || 'Processing session end message'}
                label={translations['processing_session_end_message'] || 'Processing session end message'}
                margin={"dense"}
                fullWidth={true}
                multiline
                disabled={enabledField(values)}
            />
        </>
    )
}

export default withStyles(styles, { withTheme: true })(PresetWorkSettings);
